import { useLocation } from 'react-router';

import { IonContent, IonPage, IonSpinner } from '@ionic/react';

const getClassName = (pathname: string) => {
  switch (pathname) {
    case '/guest/chat':
      return 'leps-page-content';
    case '/guest/services':
      return 'service-page-content';
    case '/guest/alert':
    case '/advocate/alert':
      return 'fa-page-content';
    case '/settings':
      return 'settings-page-content';
    default:
      return '';
  }
};

export const SuspenseFallback = () => {
  const location = useLocation();

  return (
    <IonPage>
      <IonContent fullscreen className={getClassName(location.pathname)}>
        <IonSpinner className="fallback-spinner" />
      </IonContent>
    </IonPage>
  );
};
